import React from 'react'
import { Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
import MARVEL from "../../common/utils/MarvelUrls";
import {connect} from "react-redux";

export class BillingSidebarButtons extends React.Component {
    render() {
        return (
            <div>
                <Button.Group vertical>
                    <Link to={MARVEL.BILLING.home}>
                        <Button
                            className="sidebar-buttons"
                            icon="home"
                            content=" Billing"
                        />
                    </Link>
                    <Link to={MARVEL.BILLING.organizations}>
                        <Button
                            className="sidebar-buttons"
                            icon="building outline"
                            content=" Organizations"
                        />
                    </Link>

                    <Link to={MARVEL.BILLING.manual_entry_records}>
                        <Button
                            className="sidebar-buttons"
                            icon="file alternate outline"
                            content=" Manual Entry Billing Records"
                        />
                    </Link>

                    {this.props.isBillingAdmin &&
                        <Link
                            to={MARVEL.BILLING.billing_reports}
                        >
                            <Button
                                className="sidebar-buttons"
                                icon="table"
                                content=" Billing Reports"
                            />
                        </Link>
                    }

                    <Link
                        to={MARVEL.BILLING.pricing_tables_v2}
                    >
                        <Button
                            className="sidebar-buttons"
                            icon="money bill alternate outline"
                            content=" Pricing Tables"
                        />
                    </Link>
                </Button.Group>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isBillingAdmin: state.marvel.user.access.accessLevel.isBillingAdmin,
})

const mapDispatchToProps = (state) => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingSidebarButtons);
